// Exports:
export default {
  PRIMARY: '#002857',
}

// #5D9C59